import React, { useEffect, useState } from "react";

import useAppDispatch from "../../hooks/useAppDispatch";
import useCustomSelector from "../../hooks/useCustomSelector";
import { fetchAllProducts } from "../../redux/reducers/productsReducer";
import Products from "./Products";
import { Product } from "../TestComponents";
import { Button, Typography } from "@mui/material";


const ProductsDisplay = () => {
  const dispatch = useAppDispatch();
  const products = useCustomSelector((state) => state.products.products);
  const loading = useCustomSelector((state) => state.products.loading);
  const error = useCustomSelector((state) => state.products.error);
  const [ fetchedProducts, setFetchedProducts ] = useState<Product []>()
  const [currentPage, setCurrentPage] = useState<number>(1);
  const pageSize = 10;

  useEffect(() => {
    const response = dispatch(
      fetchAllProducts({
        searchKeyword: null,
        sortBy: null,
        sortDescending: false,
        pageNumber: currentPage,
        pageSize: pageSize,
      })
    );

    // if (response && response)
  }, [dispatch, currentPage, pageSize]);

  const handleNextPage = () => {
    setCurrentPage((prevPage) => prevPage + 1);
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };

  return (
    <>
      <Typography 
        variant="h4" 
        sx={{
          fontWeight: "bold",
          padding: "1.0em",
          textAlign: "center",
        }}
      >
        All Products
      </Typography>
      {products && (
        <Products
          products={products}
          loading={loading}
          error={error}
          singleProduct={null}
        />
      )}
      <div style={{ display: "flex", justifyContent: "center", margin: "1rem" }}>
        <Button
          variant="outlined"
          onClick={handlePreviousPage}
          disabled={currentPage === 1}
        >
          Previous 
        </Button>
        <Typography style={{ margin: "0 1rem" }}>
          Page {currentPage}
        </Typography>
        <Button
          variant="outlined"
          onClick={handleNextPage}
          // disabled={!hasMoreData}
        >
          Next
        </Button>
      </div>
      
    </>
  );
};

export default ProductsDisplay;
